<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12.6521 10.8455L15.6249 13.8183C16.1246 14.3181 16.1246 15.1283 15.6249 15.6282C15.1215 16.1192 14.3184 16.1192 13.815 15.6282L10.8422 12.656C8.0356 14.5324 4.26341 13.9737 2.12111 11.3645C-0.0211886 8.75522 0.165174 4.94644 2.55197 2.5588C4.93877 0.17116 8.74748 -0.0165498 11.3575 2.12483C13.9675 4.2662 14.5275 8.0382 12.6521 10.8455ZM11.84 7.20322C11.84 4.64061 9.76256 2.56322 7.19996 2.56322C4.63853 2.56604 2.56278 4.64178 2.55996 7.20322C2.55996 9.76582 4.63736 11.8432 7.19996 11.8432C9.76256 11.8432 11.84 9.76582 11.84 7.20322Z"
          fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "SearchIcon"
}
</script>

<style scoped>

</style>
